import React from 'react';

function Contact() {
  return (
    <div className="bg-gray-100 min-h-screen p-6">
      <h2 className="text-3xl font-bold text-blue-900 mb-4">Contacto</h2>
      <p className="text-lg text-gray-700 mb-4">
        Estoy disponible para consultas y proyectos. ¡Contáctame!
      </p>
      <div className="max-w-md mx-auto">
        <p className="text-gray-700 mb-2 font-semibold">Cel: <a href="tel:+50374940422" className="text-blue-600 hover:text-blue-800">+503 74940422</a></p>
        <p className="text-gray-700 mb-2">Ubicación: El Salvador, C.A.</p>
        <p className="text-gray-700 mb-2">Email: <a href="mailto:ajflores.290992@gmail.com" className="text-blue-600 hover:text-blue-800">ajflores.290992@gmail.com</a></p>
        <a href="https://wa.me/50374940422" className="text-orange-500 hover:text-orange-600 transition-colors duration-300 font-semibold">
          WhatsApp
        </a>
        <form className="mt-6">
          <input
            type="text"
            placeholder="Nombre"
            className="w-full p-2 mb-4 border rounded-lg"
          />
          <input
            type="email"
            placeholder="Email"
            className="w-full p-2 mb-4 border rounded-lg"
          />
          <textarea
            placeholder="Mensaje"
            className="w-full p-2 mb-4 border rounded-lg"
            rows="4"
          />
          <button
            type="submit"
            className="bg-blue-900 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors duration-300"
          >
            Enviar
          </button>
        </form>
      </div>
    </div>
  );
}

export default Contact;